import A from 'utils/metrics/analytic'

import { A_wp_openWebinar, originPWebinar } from 'utils/analytics/webinars/webinar_past'
import { MaterialTypes } from 'constants/data'
import { A_lec_openLectures, originLectures } from '../library/lectures'

// Обработка кликов по плелисту видеопроекта
const A_vp_playListHandler = (typeMaterial: MaterialTypes, id: number) => {
  switch (typeMaterial) {
    case MaterialTypes.WEBINAR:
      A_wp_openWebinar(originPWebinar.PLAYLIST, id)
      break
    case MaterialTypes.ARTICLE:
      A_lec_openLectures(originLectures.PLAYLIST, id)
      break
    default:
      console.log('Нужно дописать событие для Плейлиста видеопроектов')
  }
}

// Нажатие на каждый видеопроект
const A_vp_clickVideoProject = (id: number) => {
  A.setEvent('video_project_click', { id: String(id) })
}
export { A_vp_playListHandler, A_vp_clickVideoProject }
